import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ArchiveVolumeRule } from '../models/archive/archive-volume-rule.model';
import { GlobalService } from '../providers/global.service';
import { RequestService } from '../providers/request/request.service';

@Injectable({
  providedIn: 'root',
})
export class ArchiveVolumeRuleService extends RequestService<ArchiveVolumeRule> {
  static PATH = '/archive/volume/rule';
  constructor(
    public override httpClient: HttpClient,
    private globalService: GlobalService
  ) {
    super(httpClient, ArchiveVolumeRuleService.PATH, globalService.debugUrl);
  }
}
